/** @jsxImportSource @emotion/react */
import { useMap } from '@app/contexts/ModuleMapContexts/RiskMapContext'
import { MenuItem, useTheme } from '@mui/material'
import { RootState } from '@app/redux/store'
import { Polygon, Position } from 'geojson'
import { useSelector } from 'react-redux'
import { RegionOption } from '../../RegionFilter'
import { exportButton } from './ExportRiskSummaryXlxs.styles'
import { useAtomValue } from 'jotai'
import { clientNameAtom } from '@app/state/clientsAtom'
import apiClient from '@app/config/axios.config'
import { pollForReport } from '@app/utils/pollForReport'
import { toast } from '@app/components/ui/Toast/toast'
import { userAtom } from '@app/hooks/useUserProfile'
import { logDataDogAction } from '@app/utils/logger'
import { DATADOG_ACTIONS } from '@app/app-constants'

export const ExportRiskSummaryGeoJsonButton = () => {
  const theme = useTheme()
  const { layers, drawAreas } = useSelector((state: RootState) => state.riskMap)
  const clientName = useAtomValue(clientNameAtom)
  const { regionMasks } = useMap()
  const { data: user } = useAtomValue(userAtom)

  const handleClick = async () => {
    toast({
      description:
        'Generating data for report. This may take a while, we will notify you when the report is ready.',
      type: 'info',
    })

    logDataDogAction(DATADOG_ACTIONS.EXPORT_REPORT, {
      type: 'risk-summary',
      format: 'geojson',
    })

    const assetLayers = layers.filter((layer) => layer.layerType === 'asset')
    const hazardLayers = layers.filter((layer) => layer.layerType === 'hazard')
    const regions = regionMasks ? regionMasks.map((mask: RegionOption) => mask.region) : []
    const draw_area_coordinates: Position[][] | null =
      drawAreas.length > 0 ? (drawAreas[0].geometry as Polygon).coordinates : null

    const report_id = `${user?.user_uuid}-${Date.now()}`
    try {
      await apiClient.post(`/report/export/${clientName}/risksummary-geojson/${report_id}`, {
        asset_types: assetLayers.map((layer) => layer.type),
        hazard_scenarios: hazardLayers.map((layer) => layer.assetTag),
        regions,
        draw_area_coordinates,
      })

      pollForReport(report_id, 'UrbanIntelligenceRiskSummaryGeoJSONExport.zip')
    } catch (error) {
      toast({
        description:
          'There was an error generating the report. Please notify your Urban Intelligence contact or submit feedback.',
        type: 'error',
      })
    }
  }

  return (
    <MenuItem css={exportButton({ theme })} onClick={handleClick}>
      Spatial file (GeoJSON)
    </MenuItem>
  )
}
